module.exports = __webpack_public_path__ + "img/md-dark-deeppurple.7be2e80c.svg";